import style from '../../assets/styles/UpdateMenuMessage.module.scss';

export const UpdateMenuMessage = () => {
  return (
    <div className={style.warningMessageWrapper}>
      <h1>Atualizando disponibilidade dos pratos...</h1>
    </div>
  );
};
